// sessionsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosAPI from "app/config/axiosAPI";

export const getSessions = createAsyncThunk(
    'sessions/getSessions',
    async (params) => {
      try {
        const response = await axiosAPI.get('/sessions', { params });
        return response.data;
      } catch (err) {
        return err.response.data;
      }
    }
);

export const initialState = {
  data: [],
  isLoading: false,
  isError: false
}

const sessionsSlice = createSlice({
  name: 'sessions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(getSessions.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(getSessions.fulfilled, (state, action) => {
          state.isLoading = false;
          state.data = action.payload;
          state.isError = false;
        })
        .addCase(getSessions.rejected, (state) => {
          state.isLoading = false;
          state.isError = true;
        });
  }
});

export const sessionsActions = sessionsSlice.actions;

export default sessionsSlice.reducer;